import { useEffect, useMemo, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { AppLoader } from "../../Components/common/AppLoader/AppLoader";
import { DoctorCard } from "../../Components/ui/DoctorCard/DoctorCard";
import { fetchDoctors, fetchSpecialties, fetchSpecializations } from "../../api/doctorApi";
import { getSpecialtyNames, mapDoctorToCard } from "../../utils/doctorHelpers";
import aboutusBg from "../../assets/images/aboutus-bg.png";
import "./medicalboard.css";

export const Medicalboard = () => {
  const [activeTab, setActiveTab] = useState("");
  const [doctors, setDoctors] = useState([]);
  const [specialties, setSpecialties] = useState([]);
  const [specializations, setSpecializations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      setLoading(true);
      setError("");
      try {
        const [doctorRows, specialtyRows, specializationRows] = await Promise.all([
          fetchDoctors(),
          fetchSpecialties(),
          fetchSpecializations(),
        ]);

        if (cancelled) return;

        setDoctors(doctorRows);
        setSpecialties(getSpecialtyNames(specialtyRows));
        setSpecializations(specializationRows);

        const firstSpecialty = getSpecialtyNames(specialtyRows)[0]
          || doctorRows.find((d) => d.medical_specialty)?.medical_specialty
          || "";
        setActiveTab(firstSpecialty);
      } catch (err) {
        if (!cancelled) setError(err.message || "Failed to load doctors.");
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();
    return () => { cancelled = true; };
  }, []);

  const filteredDoctors = useMemo(() => {
    const cards = doctors.map((doc) => mapDoctorToCard(doc, { specializations }));
    if (!activeTab) return cards;
    return cards.filter((doc) => doc.medicalSpecialty === activeTab);
  }, [doctors, specializations, activeTab]);

  return (
    <>
      <section
        className="mb-hero"
        style={{ backgroundImage: `url(${aboutusBg})` }}
      >
        <div className="store-page__hero-overlay">
          <Container>
            <p className="store-page__hero-label">Medical Board</p>
            <h1 className="store-page__hero-title">
              Connecting Doctor to trusted care worldwide and seamless support.
            </h1>
          </Container>
        </div>
      </section>

      <section className="mb-section">
        <Container fluid className="mb-container">
          <div className="medical-experts__top">
            <div>
              <h2 className="medical-experts__title">
                Trusted Medical Experts
              </h2>
              <p className="medical-experts__subtitle">
                Bringing global experience, compassionate care, and proven
                results.
              </p>
            </div>
          </div>

          <div className="medical-experts__tabs-wrap">
            <div className="medical-experts__tabs">
              {specialties.map((s) => (
                <button
                  key={s}
                  type="button"
                  className={`medical-experts__tab ${activeTab === s ? "medical-experts__tab--active" : ""}`}
                  onClick={() => setActiveTab(s)}
                >
                  {s}
                </button>
              ))}
            </div>
          </div>

          {loading && (
            <AppLoader className="py-5" />
          )}

          {!loading && error && (
            <p className="text-center py-4 text-danger">{error}</p>
          )}

          {!loading && !error && (
            <Row className="g-4 mt-2">
              {filteredDoctors.length > 0 ? (
                filteredDoctors.map((doc) => (
                  <Col key={doc.id} xs={12} sm={6} lg={4}>
                    <DoctorCard {...doc} />
                  </Col>
                ))
              ) : (
                <Col xs={12}>
                  <p className="text-center py-4">No doctors found for this specialty.</p>
                </Col>
              )}
            </Row>
          )}
        </Container>
      </section>
    </>
  );
};
